import { proxyClientInstance } from "../../wrappers/client";

export const getCourseOffering = (courseOfferingId) => {
  const url = `/api/faculty/v1/courseOffering?courseOfferingId=${courseOfferingId}`;
  return proxyClientInstance.get(url);
};